export default __webpack_public_path__ + "static/media/ForestPathPublic.308c3a8f.jpg";